import React, { Component } from 'react';
import { Alert, Card, CardBody, Row, Col } from 'reactstrap';
import ComparisonTable from './ComparisonTable';
import ChartLine from './ChartLine';
import { HeadlineNumber } from '../../../components/UI/HeadlineNumber';
import { connect } from 'react-redux';

class ReportDetailsIncome extends Component {

    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col sm="12" md="6">
                        <HeadlineNumber
                            title="Company held"
                            valuePounds={this.props.spvSummary.netProfitReturned}
                            description='Annual profit after tax'
                            styleName="spv"
                        />
                    </Col>
                    <Col sm="12" md="6">
                        <HeadlineNumber
                            title="Personally held"
                            valuePounds={this.props.personalSummary.netProfitReturned}
                            description='Annual profit after tax'
                            styleName="personal"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <ComparisonTable spvSummary={this.props.spvSummary} personalSummary={this.props.personalSummary} />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </React.Fragment>

        )
    }

}

class ReportDetailsNextProperty extends Component {

    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col sm="12" md="6">
                        <HeadlineNumber
                            title="Company held"
                            value={this.props.spvGoalAchieved ? this.props.spvYearsToAchieveGoal + ' years' : 'n/a'}
                            description='To purchase next property'
                            styleName="spv"
                        />
                    </Col>
                    <Col sm="12" md="6">
                        <HeadlineNumber
                            title="Personally held"
                            value={this.props.personalGoalAchieved ? this.props.personalYearsToAchieveGoal + ' years' : 'n/a'}
                            description='To purchase next property'
                            styleName="personal"
                        />
                    </Col>
                </Row>

                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <ChartLine
                                    spv={this.props.spvByYear}
                                    personal={this.props.personalByYear}
                                    field='retainedTotal'
                                    target={this.props.target}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <ComparisonTable spvSummary={this.props.spvSummary} personalSummary={this.props.personalSummary} />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </React.Fragment>
        )
    }

}

class ReportDetailsRetain extends Component {

    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col sm="12" md="6">
                        <HeadlineNumber
                            title="Company held"
                            valuePounds={this.props.spvSummary.retainedTotal}
                            description={'Profit over ' + this.props.projectionYears + ' years'}
                            styleName="spv"
                        />
                    </Col>
                    <Col sm="12" md="6">
                        <HeadlineNumber
                            title="Personally held"
                            valuePounds={this.props.personalSummary.retainedTotal}
                            description={'Profit over ' + this.props.projectionYears + ' years'}
                            styleName="personal"
                        />
                    </Col>
                </Row>

                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <ChartLine
                                    spv={this.props.spvByYear}
                                    personal={this.props.personalByYear}
                                    field='retainedTotal'
                                    target={this.props.target}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <ComparisonTable spvSummary={this.props.spvSummary} personalSummary={this.props.personalSummary} />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </React.Fragment>

        )
    }

}




class Report extends Component {
    displayName = Report.name;
    
    render() {
        return (
            <React.Fragment>

                {this.props.wizardStep >= 4 && this.props.hasCalculation &&
                    <React.Fragment>
                        {this.props.over150k &&
                            <Card>
                                <CardBody>
                                    <Alert color="danger">
                                        <p>Income over £150k not currently supported.</p>
                                    </Alert>
                                </CardBody>
                            </Card>
                        }
                        {!this.props.over150k &&
                            <React.Fragment>
                                {this.props.goal === 'retain' &&
                                    <ReportDetailsRetain
                                        spvSummary={this.props.spv.summary}
                                        personalSummary={this.props.personal.summary}
                                        spvByYear={this.props.spv.projectionsByYear}
                                        personalByYear={this.props.personal.projectionsByYear}
                                        projectionYears={this.props.projectionYears}
                                        target={null}
                                    />    
                                }
                                {this.props.goal === 'income' &&
                                    <ReportDetailsIncome
                                        spvSummary={this.props.spv.summary}
                                        personalSummary={this.props.personal.summary}
                                    />
                                }
                                {this.props.goal === 'nextProperty' &&
                                    <ReportDetailsNextProperty
                                        spvSummary={this.props.spv.summary}
                                        personalSummary={this.props.personal.summary}
                                        spvByYear={this.props.spv.projectionsByYear}
                                        personalByYear={this.props.personal.projectionsByYear}
                                        projectionYears={this.props.projectionYears}
                                        spvYearsToAchieveGoal={this.props.spv.yearsToAchieveGoal}
                                        spvGoalAchieved={this.props.spv.goalAchieved}
                                        personalYearsToAchieveGoal={this.props.personal.yearsToAchieveGoal}
                                        personalGoalAchieved={this.props.personal.goalAchieved}
                                        target={this.props.profitGoal}
                                    />
                                }
                            </React.Fragment>
                        }
                    </React.Fragment>
                }
            </React.Fragment>
        );
        
    }

}


const mapStateToProps = state => {
    return state.tax;
};


export default connect(mapStateToProps)(Report);


// WEBPACK FOOTER //
// ./src/Features/TaxCalculator/Components/Report.jsx